// KPI 레이아웃 클래스 계산 (모바일 UX Phase 1, 2026-09-21).
// 컴포넌트(KpiCard.jsx)에서 분리한 순수 함수 — JSX 가 없어 node 환경 테스트·검증 스크립트가
// 컴포넌트와 "같은 소스"를 그대로 쓸 수 있다(하드코딩된 클래스 문자열 중복 방지).
//
// 가장 중요한 계약: opt-in prop 이 없으면 기존 화면의 클래스를 100% 그대로 반환한다(회귀 방지).

export function kpiRowClass({ cols = 4, mobileLayout } = {}) {
  const colsClass = cols === 3 ? "lg:grid-cols-3" : "lg:grid-cols-4";
  return mobileLayout === "hero"
    // 320px: 1열(보조 KPI 2열 강제 금지 — 카드폭 142px 로 판독 불가) →
    // 360px+: 2열(카드폭 162px 확보). gap 12px. desktop(lg) 은 기존 복원.
    ? `grid grid-cols-1 min-[360px]:grid-cols-2 gap-3 ${colsClass}`
    // 기본(기존 화면): 종전과 완전히 동일.
    : `grid grid-cols-2 gap-2 sm:gap-3 ${colsClass}`;
}

// compact=true(축약값)면 줄바꿈 금지(break-keep). isHero 면 text-2xl.
export function kpiValueClass({ isHero = false, compact = false } = {}) {
  return [
    "font-semibold tabular-nums text-ink-900",
    compact ? "break-keep" : "break-all",
    isHero ? "text-2xl" : "text-lg sm:text-xl",
  ].join(" ");
}

// mobileHero 카드의 레이아웃(full-width + 패딩 16px). 미지정 시 기존 p-3 sm:p-4.
export function kpiCardLayoutClass({ mobileHero = false } = {}) {
  return mobileHero
    ? "min-[360px]:col-span-2 lg:col-span-1 p-4"
    : "p-3 sm:p-4";
}
